import { IconProps } from '@openeducation/oe-it-shared-types';
import * as React from 'react';
import { useTheme } from 'react-native-paper';
import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg';

export const ToolsIcon = ({ fill, width = 35, height = 35 }: IconProps) => {
  const { colors } = useTheme();

  return (
    <Svg width={width} height={height} viewBox="0 0 35 35" fill="none">
      <G clipPath="url(#clip0_190_17403)" fill={fill ?? colors.warning}>
        <Path d="M29.736 25.486l-6.998-6.998-3.004 3.003 6.999 6.998a2.112 2.112 0 003.003 0 2.138 2.138 0 000-3.003zM25.005 14.167a4.964 4.964 0 004.958-4.959c0-.821-.227-1.586-.581-2.266l-3.825 3.825-2.11-2.111L27.27 4.83c-.68-.354-1.445-.581-2.267-.581a4.964 4.964 0 00-4.958 4.958c0 .581.114 1.134.298 1.644l-2.621 2.62-2.522-2.521a1.41 1.41 0 000-1.998l-1.006-1.005L17.2 4.944a4.25 4.25 0 00-6.007 0l-3.995 4.01a1.41 1.41 0 000 1.997l1.006 1.006H4.604c-.269 0-.524.099-.708.297a.992.992 0 000 1.417l3.598 3.598a.992.992 0 001.417 0c.184-.184.298-.439.298-.708v-3.598l.991.991a1.41 1.41 0 001.998 0l2.521 2.522-8.995 8.996a2.112 2.112 0 000 3.003 2.112 2.112 0 003.003 0l14.62-14.606a4.978 4.978 0 001.657.298z" />
      </G>
      <Defs>
        <ClipPath id="clip0_190_17403">
          <Path fill="#fff" d="M0 0H34V34H0z" />
        </ClipPath>
      </Defs>
    </Svg>
  );
};
